import zod from 'zod';
import { zodPage, zodLimit, stringToListOfNumber } from './helpers';
import { defaultPermissionsValue } from '../pages/access/PermissionLevels/PermissionLevelForm';

export const WorkSchedulesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

export const SkillsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

export const SupportTicketsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const InstallationCompaniesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const InternetCompaniesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const TurnstilesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const PlatformSettingsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const AbuseReportsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

export const UserTagsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const HolidaysSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    year: zod.coerce.number().optional(),
});

export const permissionKeys = Object.keys(defaultPermissionsValue) as [
    keyof UserPermissions,
    ...(keyof UserPermissions)[]
];

export const PermissionLevelsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitIds: stringToListOfNumber.optional(),
    userId: zod.coerce.number().optional(),
    permissions: zod.array(zod.enum(permissionKeys)).optional(),
});

export const PermissionLevelFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

export const SupportTicketDetailSchema = zod.object({
    id: zod.coerce.number(),
});

export const GroupsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitIds: stringToListOfNumber.optional(),
    userId: zod.coerce.number().optional(),
    cameraId: zod.string().optional(),
});

export const GroupFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

export const UsersSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitId: zod.coerce.number().optional(),
    role: zod.coerce.number().optional(),
    phone: zod.string().optional(),
    document: zod.string().optional(),
});

export const UserFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

export const AllowedIpsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const ActingBodiesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const ActingBodyFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

export const ActingBodyUnitsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

export const ActingBodyCommandsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

export const RolesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});
